import {
  FaAward,
  FaHardHat,
  FaTrophy,
  FaUsersCog,
  FaClock,
  FaMapMarkedAlt,
} from "react-icons/fa";

const whyChooseData = [
  {
    id: 1,
    title: "Premium Quality Materials",
    description:
      "We use ITF, FIBA and international-standard sports surfacing materials for long-lasting performance.",
    icon: FaAward,
  },

  {
    id: 2,
    title: "15+ Years Experience",
    description:
      "More than a decade of experience constructing sports facilities across India.",
    icon: FaHardHat,
  },

  {
    id: 3,
    title: "5500+ Successful Projects",
    description:
      "Schools, universities, clubs, government organizations and private developers trust us.",
    icon: FaTrophy,
  },

  {
    id: 4,
    title: "Expert Engineering Team",
    description:
      "Experienced engineers ensure every project meets international quality standards.",
    icon: FaUsersCog,
  },

  {
    id: 5,
    title: "On-Time Delivery",
    description:
      "Efficient project management helps us complete projects within the promised timeline.",
    icon: FaClock,
  },

  {
    id: 6,
    title: "Pan India Service",
    description:
      "We execute sports infrastructure projects across India with dedicated support.",
    icon: FaMapMarkedAlt,
  },
];

export default whyChooseData;
